export enum VideoStatus {
  processing = 0,
  live = 1,
  deleted = 2
}

export default VideoStatus
